module.exports = "<div ng-class=\"'bc-toolbar-' + (position === 'center' ? 'center-inner' : 'element')\" ng-transclude> </div> ";